import { useState, useEffect, useCallback } from "react";
import validation, { validationContact } from "./validation";
import { CreateEntry, UpdateEntry } from '../../providers/dataProvider';
import { CheckNull } from '../../utils/Validate';
import { useLocation, useNavigate } from "react-router-dom";
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";

const useForm = (designationdata, companydata, currencydata) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    companyCode: "",
    companyName: "",
    address: "",
    phone: "",
    fax: '',
    email: "",
    website: "",
    countryId: 0,
    defaultCurrencyId: 0,
    isActive: true,
    logoUrl: "",
    headerUrl: "",
    footerUrl: "",
    createdBy: localStorage.getItem("authidentity"),
    authorizedPerson: "",
    designationId: 0,
    compContacts: []
  });
  const [country, setCountry] = useState(null);
  const [designation, setDesignation] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [condepartment, setConDepartment] = useState(null);
  const [condesignation, setConDesignation] = useState(null);
  const [formErrors, setFormError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [createMsg, setCreateMsg] = useState(null)
  const [show, setShow] = useState(false);
  const [contactShow, setContactShow] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: ""
  });
  const [contacttemp, setContactTemp] = useState({
    id: 0,
    name: "",
    email: "",
    phone: "",
    designationId: 0,
    departmentId: 0,
    designation: ""
  })
  const [contact, setContact] = useState([])
  const [contactError, setContactError] = useState({})
  const [contactSubmit, setContactSubmit] = useState(false)
  const [editCompany, setEditCompany] = useState(null);
  const [showImage, setShowImage] = useState({
    logoUrl: "",
    headerUrl: "",
    footerUrl: "",
    logoObj: "",
    headerObj: "",
    footerObj: ""
  })

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard")
        setEditCompany(item?.row);
      }
      else {
        if (item?.canAdd !== true) navigate("/dashboard")
      }
    }
    else {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    if (editCompany) {
      setFormValues({
        id: editCompany?.id,
        companyCode: editCompany?.companyCode,
        companyName: editCompany?.companyName,
        address: editCompany?.address,
        phone: editCompany?.phone,
        fax: editCompany?.fax,
        email: editCompany?.email,
        website: editCompany?.website,
        countryId: editCompany?.countryId,
        defaultCurrencyId: editCompany?.defaultCurrencyId,
        isActive: editCompany?.isActive,
        logoUrl: editCompany?.logoUrl,
        headerUrl: editCompany?.headerUrl,
        footerUrl: editCompany?.footerUrl,
        createdBy: editCompany?.createdBy,
        authorizedPerson: editCompany?.authorizedPerson,
        designationId: editCompany?.designationId,
        compContacts: editCompany?.compContacts ? editCompany?.compContacts : []
      })

      setContact(editCompany?.compContacts?.map((element, index) => {
        var designationValue = designationdata.filter(item => item.id === element?.designationId)
        if (designationValue) element.designation = designationValue[0]?.designationName
        return element;
      }
      ));
    }
  }, [editCompany, designationdata])

  const HandleFormChange = (e) => {
    const { name, value } = e.target;

    if (e.target.type === "checkbox") {
      setFormValues({
        ...formValues,
        [name]: e.target.checked,
      });

    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }

    // re-run the validation check on the changed field value
    const errors = validation({
      ...formValues,
      [name]: value
    }, companydata, showImage);
    // update the formErrors state
    setFormError({
      ...formErrors,
      [name]: errors[name]
    });
  };

  const HandleImageFileChange = (e, fileObj) => {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    setFormValues({
      ...formValues,
      [e.target.name]: file.name,
    });
    setShowImage({
      ...showImage,
      [e.target.name]: url,
      [fileObj]: file
    })

    // re-run the validation check on the changed field value
    const errors = validation({
      ...formValues,
      [e.target.name]: file.name
    }, companydata, showImage);
    // update the formErrors state
    setFormError({
      ...formErrors,
      [e.target.name]: errors[e.target.name]
    });
  }

  const HandleCountryChange = (selectedOption) => {
    setCountry(selectedOption)

    setFormValues({
      ...formValues,
      countryId: selectedOption?.value,
      phone: ""
    });

    // re-run the validation check on the changed field value
    const errors = validation({
      ...formValues,
      countryId: selectedOption?.value
    }, companydata, showImage);
    // update the formErrors state
    setFormError({
      ...formErrors,
      country: errors["country"]
    });
  };

  const HandleCurrencyChange = (selectedOption) => {
    setCurrency(selectedOption)
    setFormValues({
      ...formValues,
      defaultCurrencyId: selectedOption?.value,
    });
  };

  const HandleContactChange = (e) => {
    setContactTemp({
      ...contacttemp,
      [e.target.name]: e.target.value,
    });

    // re-run the validation check on the changed field value
    const errors = validationContact({
      ...contacttemp,
      [e.target.name]: e.target.value
    });
    // update the formErrors state
    setContactError({
      ...contactError,
      [e.target.name]: errors[e.target.name]
    });
  };

  const HandleDesignationChange = (selectedOption) => {
    setDesignation(selectedOption)
    setFormValues({
      ...formValues,
      designationId: selectedOption?.value,
    });

    // re-run the validation check on the changed field value
    const errors = validation({
      ...formValues,
      designationId: selectedOption?.value
    }, companydata, showImage);
    // update the formErrors state
    setFormError({
      ...formErrors,
      designation: errors["designation"]
    });
  };

  useEffect(() => {
    if (contactShow === false) {
      setConDepartment(null)
      setConDesignation(null)
    }
  }, [contactShow])

  const HandleConDepChange = (selectedOption) => {
    setConDepartment(selectedOption)
    setContactTemp({
      ...contacttemp,
      departmentId: selectedOption?.value,
    });

    // re-run the validation check on the changed field value
    const errors = validationContact({
      ...contacttemp,
      departmentId: selectedOption?.value
    });
    // update the formErrors state
    setContactError({
      ...contactError,
      department: errors["department"]
    });
  };

  const HandleConDesChange = (selectedOption) => {
    setConDesignation(selectedOption)
    setContactTemp({
      ...contacttemp,
      designationId: selectedOption?.value,
      designation: selectedOption?.label
    });

    // re-run the validation check on the changed field value
    const errors = validationContact({
      ...contacttemp,
      designationId: selectedOption?.value
    });
    // update the formErrors state
    setContactError({
      ...contactError,
      designation: errors["designation"]
    });
  };

  const HandleFormSubmit = (event) => {
    event.preventDefault();
    setFormError(validation(formValues, companydata, showImage));
    setIsSubmit(true);
  };

  const HandleContactSubmit = (event) => {
    setContactError(validationContact(contacttemp, contact));
    setContactSubmit(true)
  };

  useEffect(() => {
    if (Object.keys(contactError).length === 0 && contactSubmit) {
      if (contacttemp.id > 0) {
        setContact(contact?.map((element, index) => {
          if (element?.id === contacttemp?.id) {
            element.id = contacttemp.id;
            element.name = contacttemp.name;
            element.phone = contacttemp.phone;
            element.email = contacttemp.email;
            element.designationId = contacttemp.designationId;
            element.departmentId = contacttemp.departmentId;
            element.designation = contacttemp.designation;
          }
          return element;
        }
        ));
      }
      else {
        let contactUpdId = { ...contacttemp, id: (contact?.length === undefined ? 0 : contact?.length * 1) + 1 }
        setContact([...contact, contactUpdId]);
      }
      setContactShow(false);
      setContactTemp({})
      setContactSubmit(false);
    }
  }, [contactError])

  const contactClose = () => {
    setContactShow(false);
    setContactTemp({})
    setContactSubmit(false);
  }

  useEffect(() => {
    const contactlist = contact?.map((element, index) => {
      let contactdata = {
        name: element.name,
        phone: element.phone,
        email: element.email,
        designationId: element.designationId,
        departmentId: element.departmentId
      }
      return contactdata;
    }
    );
    setFormValues({ ...formValues, compContacts: contactlist })
  }, [contact])

  const DeleteContact = (delContact) => {
    const list = [...contact];
    const temp_index = list.findIndex(x => x.id === delContact.id);

    list.splice(temp_index, 1);
    setContact(list);
  }

  const EditContact = (editContactItem) => {
    setContactTemp(editContactItem)
    setContactShow(true);
  }

  const DeleteImage = (title) => {
    if (title === "headerUrl") {
      setFormValues({ ...formValues, headerUrl: "" })
      setShowImage({ ...showImage, headerUrl: "", headerObj: "" })
      setFormError({ ...formErrors, headerUrl: "" })
    }
    if (title === "footerUrl") {
      setFormValues({ ...formValues, footerUrl: "" })
      setShowImage({ ...showImage, footerUrl: "", footerObj: "" })
      setFormError({ ...formErrors, footerUrl: "" })
    }
    if (title === "logoUrl") {
      setFormValues({ ...formValues, logoUrl: "" })
      setShowImage({ ...showImage, logoUrl: "", footerObj: "" })
      setFormError({ ...formErrors, logoUrl: "" })
    }
  }

  const ClearFormValues = () => {
    setFormValues({});
    navigate("/company-master")
  }

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      setDisabledSubmit(true);
      if (CheckNull(formValues?.id) !== "") {
        UpdateEntry("company", { ...formValues, companyId: formValues.id }, setCreateMsg, SuccessMessages?.UPDATED("Company"), ErrorMessages?.UPDATE_ERROR("Company"))
      } else {
        CreateEntry("company", formValues, setCreateMsg, SuccessMessages?.CREATED("Company"), ErrorMessages?.CREATE_ERROR("Company"))
      }
      setFormError({});
    }
    setIsSubmit(false);
  }, [formErrors]);

  useEffect(() => {
    setDisabledSubmit(false);
    if (CheckNull(createMsg?.message).includes("Failed")) {
      setErrorShow(
        {
          show: true,
          errorMessage: createMsg.successData
        })
      setFormValues({})
    }
    else if (CheckNull(createMsg?.message) !== "") {
      setShow(true)
      setFormValues({})
    }
  }, [createMsg])

  const SuccessDoneClick = () => {
    setShow(false);
    navigate("/company-master")
  }

  const ErrorDoneClick = () => {
    setErrorShow(
      {
        show: false,
        errorMessage: ""
      })
    setCreateMsg(null);
  }

  return {
    HandleFormChange,
    formValues,
    setFormValues,
    country,
    HandleCountryChange,
    designation,
    HandleDesignationChange,
    HandleFormSubmit,
    formErrors,
    HandleImageFileChange,
    createMsg,
    show,
    setShow,
    contactShow,
    setContactShow,
    HandleContactChange,
    contacttemp,
    setContactTemp,
    HandleConDepChange,
    condepartment,
    HandleConDesChange,
    condesignation,
    HandleContactSubmit,
    contact,
    DeleteContact,
    EditContact,
    setConDesignation,
    setConDepartment,
    contactError,
    DeleteImage,
    ClearFormValues,
    setCountry,
    setDesignation,
    currency,
    setCurrency,
    HandleCurrencyChange,
    SuccessDoneClick,
    ErrorDoneClick,
    errorShow,
    showImage,
    contactClose,
    disabledSubmit,
    setFormError,
    setContactError
  };
};

export default useForm;
